import React, { useEffect, useState } from 'react';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { ListStore } from '../store';
import IframeVideo from './IframeVideo';
import { jsonp } from '@ifeng-fe/ui_base';

const IframeVideoBox = () => {
    const listStore = ListStore.useContainer();
    const { listStates } = listStore;
    const { liveInfo } = listStates;
    const [liveData, setLiveData] = useState({});

    const getLiveData = async liveId => {
        const res = await jsonp(`https://shankapi.ifeng.com/api/timeline/live/${liveId}/info/getLiveDataCallBack`, {
            jsonpCallback: 'getLiveDataCallBack',
            cache: false,
        });

        if (res?.data?.liveId) {
            setLiveData(res.data);
        }
    };

    useEffect(
        () => {
            if (liveInfo?.liveId) {
                getLiveData(liveInfo.liveId);
            }
        },
        [liveInfo?.liveId],
    );

    return liveData?.liveId ? <IframeVideo liveData={liveData} /> : null;
};

export default errorBoundary(IframeVideoBox);
